import {
  Delete16Regular,
  Rename16Regular,
  ShareIos20Regular,
} from '@/components/Icon'

export const DOCUMENT_MENU_ACTION = {
  SHARE: 'share',
  RENAME: 'rename',
  DELETE: 'delete',
}

/** Document row actions (no download). */
export const DOCUMENT_ROW_MENU_ITEMS = [
  { id: DOCUMENT_MENU_ACTION.SHARE, label: 'Share', Icon: ShareIos20Regular },
  { id: DOCUMENT_MENU_ACTION.RENAME, label: 'Rename', Icon: Rename16Regular },
  {
    id: DOCUMENT_MENU_ACTION.DELETE,
    label: 'Delete',
    Icon: Delete16Regular,
    variant: 'danger',
    showDividerBefore: true,
  },
]
